import React from 'react';
import ReactDOM from 'react-dom';
import * as rmd from 'material-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import styled from 'styled-components';

import LeftIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import RightIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

import SMPostDialog from '../SMPostDialog';
import color from 'color';
import config from 'cfg';

import TrackVisibility from 'react-on-screen';

const SMStreamContainer = styled.div`
    margin-bottom: 5px;
`;
const SMHeader = styled.div`
    position: relative;
    padding: 25px 0px;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
    h1 {
        margin: 0;
        font-size: 36px;
        line-height: 40px;
        flex-grow: 1;

        font-weight: 300;
    }
    &:after {
        position: absolute;
        content: '';
        display: inline-block;
        height: 2px;
        width: 100px;
        background: red;
        bottom: 0px;
    }
`;

const Stack = styled.div`
    width: 480px;
    display: grid;
    position: relative;
    grid-template-columns: 1fr;

    & > * {
        grid-column: 1 / 1;
        grid-row: 1 / 1;
    }

    .main-frame {
        z-index: 3;
    }
`;

const Grid = styled.div`
    display: flex;
    margin: 0 -15px;
    flex-wrap: wrap;
    margin-bottom: 140px;

    @media (max-width: 1156px) {
        align-items: center;
        justify-content: center;
        margin: 0px;
    }

    .smi-widget {
        width: 480px;
        min-height: 1px !important;
        overflow: hidden;
        min-width: 1px !important;
        pointer-events: none;
    }

    .item-single {
        .header {
            height: 40px;
            position: relative;
            color: #fff;
            font-weight: 300;
            label {
                display: block;
                line-height: 40px;
                text-align: center;
            }
        }
    }
    .column {
        margin: 0 15px;
        .stack-item {
            margin-bottom: 15px;
            border-radius: 2px;
        }
    }
    .top-overlay {
        position: absolute;
        right: 0;
        top: 0;
    }

    .smi-widget-box {
        position: relative;
        text-align: center;
        overflow: hidden;
        .widget-cont {
        }
    }
`;

const StackViewContainer = styled.div`
    position: relative;
    cursor: pointer;
    border-radius: 2px;
    overflow: hidden;
    &:hover {
        transition: box-shadow 0.3s ease-in-out;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    }

    &:hover:before {
        content: '';
        position: absolute;
        left: -5px;
        right: -5px;
        top: -5px;
        bottom: -5px;
        background: #f2f2f2;
        z-index: -1;
        border-radius: 2px;
    }
    .share {
        display: none;
    }
    &:hover {
        position: relative;
        .share {
            display: block;
        }
        .smi-widget-box:after {
            content: '';
            position: absolute;
            left: 0px;
            right: 0px;
            top: 0px;
            bottom: 0px;
            background: #000;
            opacity: 0.2;
            z-index: 1;
            border-radius: 2px;
        }
    }

    .widget-info {
        background: #555;
        position: relative;
        display: flex;
        align-items: center;
        h3 {
            font-weight: 300;
            margin-bottom: 4px;
            margin-top: 4px;
            padding-left: 10px;
            font-size: 22px;
        }
    }

    .pagination {
        text-align: center;

        * {
            vertical-align: middle;
        }
        .dots {
            box-sizing: content-box;
            padding: 12px;

            display: inline-block;
            line-height: 24px;
        }
        .dot {
            display: inline-block;
            vertical-align: middle;
            width: 6px;
            height: 6px;
            margin: 0 2px;
            border-radius: 50%;
            opacity: 0.8;
            background-color: #fff;
            &.active {
                opacity: 1;
            }
        }
    }
`;
var C_DISPLAY_TYPE_KEY = 'C_DISPLAY_TYPE_KEY';

class StackView extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            index: 0
        };
    }

    render = () => {
        return (
            <StackViewContainer>
                {this.props.children[this.state.index]}
                <div className="widget-info" style={{ display: 'flex' }}>
                    <h3 style={{ flexGrow: 1, alignItems: 'center' }}>{this.props.title}</h3>
                    <rmd.IconButton
                        disabled={this.state.index === 0}
                        onClick={e =>
                            this.setState({
                                index: (this.state.index - 1) % this.props.children.length
                            })
                        }
                    >
                        <LeftIcon color={'#fff'} />
                    </rmd.IconButton>

                    <rmd.IconButton
                        disabled={this.state.index === this.props.children.length - 1}
                        onClick={e =>
                            this.setState({
                                index: (this.state.index + 1) % this.props.children.length
                            })
                        }
                    >
                        <RightIcon color={'#fff'} />
                    </rmd.IconButton>
                </div>
            </StackViewContainer>
        );
    };
}

class StackOrder extends React.Component {
    componentDidMount = () => {};
    componentWillUnmount = () => {
        if (this.timeout) clearTimeout(this.timeout);
    };

    state = {
        load: 'none',
        failed: false,
        loadall: false
    };

    renderStub = previewUrl => (
        <Stack>
            <img
                style={{ width: 480, filter: 'blur(14px)' }}
                src={previewUrl}
                onLoad={() => {
                    this.setState({ hwidget: true });
                }}
            />
        </Stack>
    );

    renderJSEmbed = () => {
        if (!this.setState.mainLoaded) {
            this.timeout = setTimeout(() => {
                this.setState({ mainLoaded: true });
            }, 2000);
        }

        return <div className="main-frame">{this.props.jsWidget}</div>;
    };

    render = () => {
        let { url, preview, loadall, name } = this.props;
        let { hwidget = false, hinstance = false, hstate = false, failed, mainLoaded = false } = this.state;
        let hide1 = hstate || hinstance;
        let previewUrl = preview && preview.url ? preview.url : `${url}&wdpcache=widget`;
        if (!loadall) return this.renderStub(previewUrl);

        return (
            <Stack>
                {!mainLoaded && (
                    <img
                        style={{ width: 480, filter: 'blur(14px)', visibility: !hide1 ? 'visible' : 'invisible' }}
                        src={preview && preview.url ? preview.url : `${url}&wdpcache=widget`}
                        onLoad={() => {
                            this.setState({ hwidget: true });
                        }}
                    />
                )}

                {!failed && (
                    <img
                        className="main-frame"
                        style={{ width: 480, visibility: hstate ? 'visible' : 'hidden' }}
                        src={`${url}&wdpcache=state`}
                        onLoad={() => {
                            this.setState({ hstate: true, mainLoaded: true });
                        }}
                        onError={() => {
                            this.setState({ failed: true });
                        }}
                    />
                )}
                {failed && this.renderJSEmbed()}
            </Stack>
        );
    };
}

class SMStream extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.templateObserver = this.context.templateObserver;
        this.state = {
            smWidgets: [],
            collapsed: false,
            wasVisible: false,
            display: localStorage.getItem(C_DISPLAY_TYPE_KEY) || 'row'
        };
    }

    componentDidMount = () => {
        if (this.templateObserver) {
            this.templateObserver.subscribe(this.handleTempleateUpdate);
        }
        this._debounceHandleScreenSizeUpdate = _.debounce(this.handleScreenSizeUpdate.bind(this), 100);
        window.addEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
        this.loadData().then(res => {
            this.setState(res);
        });
    };

    componentWillReceiveProps(nextProps) {
        this.setState(() => {
            this.loadData(nextProps).then(data => this.setState(data));
        });
    }

    componentWillUnmount() {
        if (this.templateObserver) {
            this.templateObserver.unsubscribe(this.handleTempleateUpdate);
        }
        window.removeEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
    }

    handleTempleateUpdate = () => {
        this.forceUpdate();
    };

    loadData = params => {
        var user = this.context.user;
        params = params || this.props || {};
        if (!user || !user.client) return null;
        return this.loadSMWidgets(params).then(allWidgets => {
            return RCore.promiseProps({
                smWidgets: allWidgets.filter(w => this.context.widgets.find(aw => aw.id === w.name)),
                loaded: true
            });
        });
    };

    static contextTypes = {
        user: PropTypes.object.isRequired,
        templateObserver: PropTypes.object.isRequired,
        campaigns: PropTypes.array.isRequired,
        widgets: PropTypes.array.isRequired
    };

    handleScreenSizeUpdate = () => {
        var width = ReactDOM.findDOMNode(this).offsetWidth;

        this.setState({ width });
    };

    loadSMWidgets = () => {
        return Promise.resolve(this.props.smWidgets || []);
    };

    renderSMImage = (name, props, key, displayVisible, cardProps) => {
        const { user, widgets } = this.context;
        let templateId = this.templateObserver.getTemplate();

        const style = {};

        var widget = _.find(widgets, w => w.id === name);
        let load = 'sm';
        if (widget.spec.video) load = 'video';

        var propsJS = _.extend(RCore.dataAttributesToObject(props), {
            template: templateId,
            lang: user.props.lang,
            tz: _.get(user, 'props.timezone', 'CET')
        });

        let widgetURL = config.WDPLinkr.widget.image(user.client, user.username, 'default', name, propsJS);

        return (
            <div
                className="smi-widget-box"
                style={style}
                key={widgetURL}
                onClick={e => {
                    this.handleShare(name, props, widget.spec);
                }}
            >
                {load !== 'video' && (
                    <StackOrder
                        key={widgetURL + '_' + displayVisible}
                        preview={widget.preview}
                        url={widgetURL}
                        loadall={displayVisible}
                        mode="js"
                        name={name}
                        jsWidget={
                            <rlz-widget
                                class="smi-widget"
                                data-name={name}
                                data-load={load}
                                data-client={user.client}
                                data-user={user.username}
                                data-lang={_.get(user, 'props.lang')}
                                data-tz={_.get(user, 'props.timezone', 'CET')}
                                data-token={user.accessToken}
                                data-template={templateId}
                                data-theme={user.defaultTheme}
                                data-min-width={800}
                                data-sm-browser
                                data-zoom={0.6}
                                {...props}
                            />
                        }
                    />
                )}
                {load === 'video' && (
                    <rlz-widget
                        key={name}
                        class="smi-widget"
                        data-name={name}
                        data-load={'animated'}
                        data-client={user.client}
                        data-user={user.username}
                        data-lang={_.get(user, 'props.lang')}
                        data-tz={_.get(user, 'props.timezone', 'CET')}
                        data-token={user.accessToken}
                        data-template={templateId}
                        data-theme={user.defaultTheme}
                        data-min-width={800}
                        data-sm-browser
                        data-zoom={0.6}
                        {...props}
                    />
                )}
            </div>
        );
    };

    handleShare = (name, props, spec) => {
        this.setState({
            preview: true,
            previewWidget: {
                name,
                props: _.clone(props),
                spec
            }
        });
    };

    renderToolbar() {
        return <h1>{this.props.title || this.constructor.name}</h1>;
    }

    renderGroupedWidgets = (cols, displayVisible = false) => {
        if (cols === 0) return <div />;

        let { smWidgets } = this.state;
        var groupedWidgetPairs = _.chain(smWidgets)
            .groupBy(w => w.groupKey || w.name)
            .toPairs()
            .value();

        var columns = _.range(cols).map(i => []);
        groupedWidgetPairs.forEach((w, i) => columns[i % cols].push(w));

        return (
            <Grid>
                {columns.map((widgets, index) => {
                    return (
                        <div className="column" key={index}>
                            {widgets.map((pair, i) => {
                                var name = pair[0];
                                var widgets = pair[1];
                                var title = widgets[0].groupTitle || widgets[0]['data-title'] || name;
                                var desc = widgets[0].groupDesc;
                                var minHeight = widgets[0].minHeight;

                                return (
                                    <div key={name + '_' + i} className="stack-item">
                                        <StackView
                                            title={title}
                                            desc={desc}
                                            widgets={widgets}
                                            onShare={this.handleShare}
                                        >
                                            {widgets.map(sm => {
                                                return this.renderSMImage(sm.name, sm.props, sm.key, displayVisible, {
                                                    minHeight
                                                });
                                            })}
                                        </StackView>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </Grid>
        );
    };

    render() {
        let templateId = this.templateObserver.getTemplate();
        let { previewWidget, preview, loaded, smWidgets } = this.state;

        if (!loaded || (loaded && smWidgets.length === 0)) return <div>"empty"</div>;

        // if (this.container) cols = Math.floor(this.container.offsetWidth / 500);
        let cols = 3;
        return (
            <div>
                <TrackVisibility
                    once
                    partialVisibility
                    ref={c => {
                        this.container = c;
                    }}
                >
                    {({ isVisible }) => (
                        <SMStreamContainer>
                            <SMHeader>{this.renderToolbar()}</SMHeader>
                            {this.renderGroupedWidgets(cols, isVisible)}
                        </SMStreamContainer>
                    )}
                </TrackVisibility>
                {previewWidget &&
                    preview && (
                        <SMPostDialog
                            eventId={this.props.eventId}
                            templateId={templateId}
                            previewWidget={previewWidget}
                            widgetName={previewWidget.name}
                            showAllParams={false}
                            open={preview}
                            onRequestClose={() =>
                                this.setState({
                                    preview: false
                                })
                            }
                        />
                    )}
            </div>
        );
    }
}

export default SMStream;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/streams/SMStream.js
 **/